import React, { ReactNode } from 'react';

import Stack from '@mui/material/Stack';

import { Navbar } from '@mais-retorno-front/components/navbar';
import { Footer } from '@mais-retorno-front/components/footer';
import themeColors from '@mais-retorno-front/theme/theme-variables';
import { AppFooterWithServiceTerms } from '../app/componentes/footer';
import { Breadcrumbs } from '@mais-retorno-front/components/breadcrumbs';
import { IBreadcrumbs } from '@mais-retorno-front/models/breadcrumbs.model';

import { FooterContainer } from './styles';

interface DefaultLayoutProps {
  children: ReactNode;
  breadcrumbs: IBreadcrumbs[];
  backgroundColor?: string;
  removeMainTag?: boolean;
  showFooterServiceTerms?: boolean;
}

export default function DefaultLayout({
  children,
  breadcrumbs,
  showFooterServiceTerms = false,
  backgroundColor = themeColors.colors.backgroundColor,
  removeMainTag = false,
}: DefaultLayoutProps) {
  return (
    <>
      <style jsx global>{`
        body {
          background-color: ${backgroundColor};
        }
      `}</style>
      <Navbar />
      {removeMainTag ? (
        <div className="app">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          </Stack>
          {children}
        </div>
      ) : (
        <main className="app">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          </Stack>
          {children}
        </main>
      )}

      {showFooterServiceTerms && (
        <FooterContainer>
          <AppFooterWithServiceTerms />
        </FooterContainer>
      )}

      <Footer />
    </>
  );
}
